import React, { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";

const EmailForm = ({ onSubmitCallback, sendOneEmail,rows, emails, dataGC }) => {

    const [emailList, setEmailList] = useState([]);
    const [dataNotification, setDataNotification] = useState([]);

    useEffect(() => {
        setDataNotification(dataGC);
    }, [dataGC]);

    useEffect(() => {
        setEmailList(emails);
    }, [emails]);

    const fillEmails = (key, value, productId) => {
        const email = [...emailList];
        const dataGC = [...dataNotification];
        if(productId) {
            email[key] = value;
            dataGC[key] = {
                value,
                productId,
            }
        } else {
            rows.forEach((x, i) => {
                email[i] = value;
                dataGC[i] = {
                    value,
                    productId: x,
                }
            })
        }
        setEmailList(email);
        setDataNotification(dataGC);
    }

     const onSubmit = (e) => {
        e.preventDefault()
        onSubmitCallback(emailList, dataNotification);
     }

    return (
        <Form onSubmit={onSubmit}>
            <Form.Label>
                You have purchased a Gift Card. Please enter the email address of the user you would like to send the gift card to.
            </Form.Label>
            {rows?.length > 0 && rows.map((x, key) => {
                if (sendOneEmail && key > 0) {
                    return null;
                }
                return (
                    <Form.Group key={key}>
                        <Form.Control
                            type="email"
                            id={`formBasicEmail_${key}`}
                            name={`email_${key}`}
                            placeholder="Enter email"
                            value={emailList[key]}
                            onChange={(e) => fillEmails(key, e.target.value, x)}
                        />
                    </Form.Group>
                );
            })}
            <Button variant="primary" type="submit" block>
                Send
            </Button>
        </Form>
    );
};


export default EmailForm;
